import { FC } from 'react';
import SectionTitleArrow from '../section-title-arrow/SectionTitleArrow';
import Link from 'next/link';
import ScrollCardsList from '../scroll-cards-list/ScrollCardsList';
import { DEV_ABSOLUTE_URL } from '@/helpers/variables';
import { IOtherAuthorBook } from '@/interfaces/bookDetail.interface';
import { hideImgOnError } from '@/helpers/helpers';
import styles from './SimilarBooks.module.scss';
import { IBookShortDetailOtherAuthorBook } from '@/interfaces/bookShortDetail.interface';

interface ISimilarBooks {
  books: IBookShortDetailOtherAuthorBook[];
  authorName: string;
  authorId: number;
}

const SimilarBooks: FC<ISimilarBooks> = ({ books, authorName, authorId }) => {
  const authorFullAlias = `/library/author/${authorId}`;

  return (
    <>
      <div className={styles.similarBook}>
        <SectionTitleArrow name={'Другие книги автора'} alias={authorFullAlias} />

        <ScrollCardsList>
          {books.map((book) => {
            const { title, id } = book.book;
            return (
              <div key={id} className={styles.similarBook__item}>
                <div className={styles.similarBook__imgWrap}>
                  <Link prefetch={false} className={styles.similarBook__imgLink} href={`/book/${book.id}`}>
                    <img loading="lazy" className={styles.similarBook__img} src={`${DEV_ABSOLUTE_URL}/covers_200/${book.book.external_id}.jpg`} width="180" height="240" alt={title} onError={hideImgOnError} />
                  </Link>
                </div>

                <div className={styles.similarBook__name}>
                  <Link prefetch={false} className={styles.similarBook__link} href={`/book/${book.id}`}>
                    {title}
                  </Link>
                </div>
                <div className={styles.similarBook__author}>
                  <Link prefetch={false} className={styles.similarBook__link} href={authorFullAlias}>
                    {authorName}
                  </Link>
                </div>
              </div>
            );
          })}
        </ScrollCardsList>
      </div>
    </>
  );
};

export default SimilarBooks;
